import { useFlags } from 'flagsmith/react';

import useAcl from '@/utils/hooks/user/useAcl';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useIsGroup from '@/utils/hooks/user/useIsGroup';

import { aclFeatures } from '@/lib/acl/aclFeatures';
import { FACEBOOK, INSTAGRAM } from '@/lib/socialProfile';

export const useDMAccess = () => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const { hasAcl } = useAcl();
    const isGroup = useIsGroup();
    const flags = useFlags(['facebook_dm']);
    const hasDirectMessagesAccess = hasAcl(aclFeatures.direct_messages.base.read);

    const isDMEnabledForSocialProfile =
        activeSocialProfile?.social_network_type === INSTAGRAM ||
        (activeSocialProfile?.social_network_type === FACEBOOK && flags?.facebook_dm?.enabled);

    return isDMEnabledForSocialProfile && !isGroup && hasDirectMessagesAccess;
};
